import React from "react";
import { useTranslation } from "react-i18next";
import { getSettings, toAppUrl } from "src/services/configService";

import { CollapsibleLink, ExternalLink } from "../NavigationLinks/NavigationLinks";

const ossLicensesUrl = toAppUrl("embedded/third-party");

export const HelpLinksSection = () => {
    const { t } = useTranslation(["common", "sidepanels"]);
    const { features } = getSettings();
    const helpLinks = features.helpLinks;
    const hasAnyHelpLink =
        (helpLinks && Object.values(helpLinks).some((url) => url)) || features.pages.ossLicensesPageEnabled;

    if (!hasAnyHelpLink) {
        return null;
    }

    return (
        <CollapsibleLink title={t("sidepanels:navigationMenu.help")} startIcon="fa-regular fa-circle-question">
            {helpLinks?.discussionForum ? (
                <ExternalLink title={t("common:label.discussionForum")} url={helpLinks.discussionForum} />
            ) : null}
            {helpLinks?.knowledgeBase ? (
                <ExternalLink title={t("sidepanels:navigationMenu.knowledgeBase")} url={helpLinks.knowledgeBase} />
            ) : null}
            {helpLinks?.privacyPolicy ? (
                <ExternalLink title={t("sidepanels:navigationMenu.privacyPolicy")} url={helpLinks.privacyPolicy} />
            ) : null}
            {helpLinks?.termsOfUse ? (
                <ExternalLink title={t("sidepanels:navigationMenu.termsOfUse")} url={helpLinks.termsOfUse} />
            ) : null}
            {helpLinks?.legalNotice ? (
                <ExternalLink title={t("sidepanels:navigationMenu.legalNotice")} url={helpLinks.legalNotice} />
            ) : null}
            {features.pages.ossLicensesPageEnabled ? (
                <ExternalLink title={t("sidepanels:navigationMenu.thirdPartyLicenses")} url={ossLicensesUrl} />
            ) : null}
        </CollapsibleLink>
    );
};
